import { ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import Iconify from '../iconify';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { useState } from 'react';
import { QuestionType } from '@/@types/api.types.ts';

const reorder = (list: any, startIndex: number, endIndex: number) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

interface QuestionsOrderingTableProps {
  form: any;
  questions: QuestionType[];
}

export const QuestionsOrderingTable = ({
  questions,
  form,
}: QuestionsOrderingTableProps) => {
  const [state, setState] = useState({ questions });
  function onDragEnd(result: any) {
    console.log('result', result);
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    const questions = reorder(
      state.questions,
      result.source.index,
      result.destination.index
    ).map((question: any, index) => {
      question.order = index;
      return question;
    });

    form.setFieldValue('questions', questions);
    setState({ questions });
  }
  console.log('state.questions', state.questions);
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId='droppable'>
        {(provided: any) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {state.questions.map((item, index) => (
              <Draggable
                key={item.question_id}
                draggableId={item.question_id.toString()}
                index={index}
              >
                {(provided: any) => (
                  <ListItem
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                  >
                    <ListItemAvatar>
                      <Iconify icon='eva:flip-outline' />
                    </ListItemAvatar>
                    <ListItemText primary={item.title_en} secondary='' />
                  </ListItem>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};
